import { createAsyncThunk } from '@reduxjs/toolkit';
import { SERVER_URL, getHeaders, handleResponse } from '../apiConfig';

export const fetchVideoDetails = createAsyncThunk(
  'videoEdit/fetchVideoDetails',
  async (videoId, { rejectWithValue }) => {
    try {
      const response = await fetch(`${SERVER_URL}/api/video-index/single/${videoId}`, {
        headers: getHeaders()
      });
      const data = await handleResponse(response);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch video details.');
    }
  }
);

export const trimVideo = createAsyncThunk(
  'videoEdit/trimVideo',
  async (trimData, { rejectWithValue }) => {
    try {
      const response = await fetch(`${SERVER_URL}/api/video-index/trim`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(trimData)
      });
      const data = await handleResponse(response);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to trim video.');
    }
  }
);
